import React, { createContext, useState } from 'react';
import type { BellaRequest, MfState } from 'Server/types/bellaRequest';

export interface MfServerSideData {
    state: MfState;
    setMfState: (mfName: string, actionName: string, data?: any) => void;
}

export const MfServerSideDataContext = createContext<MfServerSideData>({
    state: {},
    setMfState: () => {},
} as MfServerSideData);
const { Provider, Consumer } = MfServerSideDataContext;
export { Consumer as MfServerSideDataConsumer };

const MfServerSideDataProvider = ({
    children,
    prefetchedData,
    req,
}: {
    children: React.ReactNode;
    prefetchedData?: MfState;
    req?: BellaRequest;
}) => {
    const [state, setState] = useState(prefetchedData || req?.mfState || {});
    const setMfState = (mfName: string, actionName: string, data?: any) => {
        state[mfName] = {
            ...(state?.[mfName] ? state?.[mfName] : {}),
            [actionName]: data,
        };
        setState({ ...state });

        if (req) {
            req.mfState = state;
        }
    };

    return <Provider value={{ state, setMfState }}>{children}</Provider>;
};

export default MfServerSideDataProvider;
